var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.images.length)?_c('div',{staticClass:"multi_img",class:_vm.classObject},_vm._l((_vm.thumbImages),function(image,index){return _c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(image),expression:"image"}],key:index,on:{"click":function($event){$event.stopPropagation();return _vm.onPreview(index)}}})}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }